import React, { useEffect } from 'react';
import { Tooltip } from '@material-ui/core';

import EditSelectYear from '../../../../components/table/EditSelectYear';
import EditSelect from '../../../../components/table/EditSelect';
import { MonetaryFloatInput } from '../../../../components/common/MonetaryFloatInput';
import { years } from '../../../../helpers';
import { floatRenderer } from '../../../../services/formatSvc';

export const renderTooltip = (content, tooltip) => (
  <Tooltip placement="top" title={<span style={{ fontSize: 14 }}>{tooltip}</span>}>
    <span>{content}</span>
  </Tooltip>
);

const getCostAgrsDictionary = (props, cell, isKvrDependant) => {
  if (!isKvrDependant) return props.plansDictionary.costAgrs;
  if (!cell.rowData.costKvrId) return [];
  return props.plansDictionary.costKvrs.find((ck) => ck.id === cell.rowData.costKvrId).costAgrs;
};

export const editComponentsHelper = {
  getYearControl: (cell) => (
    <EditSelectYear value={cell.value} onChange={cell.onChange} />),
  getMonetaryControl: (cell) => (
    <MonetaryFloatInput style={{ fontSize: '16px' }} value={cell.value} onChange={cell.onChange} table />),

  // Справочники с сервера
  getAgreementControl: (props) => (cell) => (
    <EditSelect value={cell.value} onChange={cell.onChange} data={props.plansDictionary.agreements} labelField="num" />),
  getBcCodeControl: (props) => (cell) => (
    <EditSelect value={cell.value} onChange={cell.onChange} data={props.plansDictionary.bcCodes} labelField="fullCode" />),
  getFundingControl: (props) => (cell) => (
    <EditSelect value={cell.value} onChange={cell.onChange} data={props.plansDictionary.fundings} />),

  getCostAgrsControl: (props, fromSelectedKvr, labelField = 'num') => (cell) => (
    <EditSelect value={cell.value} onChange={cell.onChange} data={getCostAgrsDictionary(props, cell, fromSelectedKvr)} labelField={labelField} />),
  getCostKvrsControl: (props, labelField = 'num') => (cell) => {
    const onChange = (costKvrId) => cell.onRowDataChange({ ...cell.rowData, costKvrId, costAgrId: '' });
    return (
      <EditSelect value={cell.value} onChange={onChange} data={props.plansDictionary.costKvrs} labelField={labelField} />);
  },

  getCostAgrsLabel: (props) => ({ rowData }) => (rowData.costAgrId
    ? props.plansDictionary.costAgrs.find((ca) => ca.id === rowData.costAgrId).name
    : null),
  getCostKvrsLabel: (props) => ({ rowData }) => (rowData.costKvrId
    ? props.plansDictionary.costKvrs.find((ck) => ck.id === rowData.costKvrId).name
    : null),
};

export const filtersHelper = {
  getYearsLookup: () => years.reduce((acc, y) => ({ ...acc, [y]: y }), {}),
  getAgreementLookup: (props) => props?.agreements?.filter((a) => !props?.years?.length || a.kpsCodes.some((c) => props.years.includes(c.year))).reduce((acc, a) => ({ ...acc, [a.id]: a.num }), {}) ?? {},
  getFundingLookup: (props) => props?.fundings?.reduce((acc, f) => ({ ...acc, [f.id]: f.name }), {}) ?? {},
  getBcCodeLookup: (props) => props?.bcCodes?.reduce((acc, bc) => ({ ...acc, [bc.id]: bc.fullCode }), {}) ?? {},
  getCostAgrsNameLookup: (props) => props?.costAgrs?.reduce((acc, ca) => ({ ...acc, [ca.name]: ca.name }), {}) ?? {},
  getCostKvrsNameLookup: (props) => props?.costKvrs?.reduce((acc, ck) => ({ ...acc, [ck.name]: ck.name }), {}) ?? {},
  getCostAgrsNumLookup: (props) => props?.costAgrs
    ?.filter((ca) => !props?.years?.length || ca.agreements.some((a) => a.kpsCodes.some((c) => props.years.includes(c.year))))
    .reduce((acc, ca) => ({ ...acc, [ca.id]: ca.num }), {}) ?? {},
  getCostKvrsNumLookup: (props) => props?.costKvrs?.reduce((acc, ck) => ({ ...acc, [ck.id]: ck.num }), {}) ?? {},
};

// {
//   lookup: headFilterLookup,
//   customFilterAndSearch: (term, rowData) => term.length === 0 || rowData.head && term.indexOf(rowData.head.displayName) >= 0
// }

export const highlightNegative = (rem) => <span style={{ color: rem < 0 ? 'red' : 'inherit' }}>{floatRenderer(rem)}</span>;
